import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { fetchDetailRole } from 'actions/Admin'
import DetailRoleView from 'components/pages/adminManagement/role/Detail'
import { updateSiteConfiguration } from 'actions/Site'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  fetchDetailRole: bindActionCreators(fetchDetailRole, dispatch),
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isFetching', 'setIsFetching', false),
  withState('detail', 'setDetail', {
    data: {},
    meta: {},
    isFetching: true,
  }),
  withHandlers({
    getDetail: props => (id) => {
      const { setDetail } = props
      props.fetchDetailRole(id)
        .then((result) => {
          setDetail({
            data: result.data,
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch(() => {
          setDetail({
            data: {},
            meta: {},
            isFetching: false,
          })
        })
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Role', 'Detail'])
      this.props.updateSiteConfiguration('titlePage', 'Role')
      const { getDetail, match } = this.props
      getDetail(match.params.id)
    },
  }),
)(DetailRoleView)
